import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectEventTicketsQueryItems } from '../../../../../redux/event/event-tickets/selector';
import { eventTickets } from '../../../../../redux/event/event-tickets/action';
import PageLoader from '../../../../../components/PageLoader';
import EventTicketsComponent from '../components/event-ticket.component';
import { selectEventsListItems } from '../../../../../redux/event/events/selector';
import { events } from '../../../../../redux/event/events/action';

const AgencyEventTicket = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const eventsListItems = useSelector(selectEventsListItems)
    const eventsTicketsQuery = useSelector(selectEventTicketsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const [
        selectedEventTickets,
        setSelectedEventTickets
    ] = useState<any>([])

    const fetchEventTicketsQueryById = () => {
        dispatch(eventTickets.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/query`, entity: 'eventTickets', jsonData: {

                Records: [
                    {
                        Id: parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        })




    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedEventTickets({ ...selectedEventTickets, [field]: event })
    }
    useEffect(() => {
       dispatch(events.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/list`,
         entity: 'events',
         jsonData: {}
       })).then(() => {
      if (parmas?.id > 0) {
        fetchEventTicketsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedEventTickets(eventsTicketsQuery?.result?.items)

            }
        },
        [isQuery]
    )
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        const eventTicketsCreateItemData = {


            EventId: selectedEventTickets?.EventId,
            Name: selectedEventTickets?.Name,
            Description: selectedEventTickets?.Description,
            Price: selectedEventTickets?.Price,
            Currency: selectedEventTickets?.Currency,
            QuantityAvailable: selectedEventTickets?.QuantityAvailable,
            QuantitySold: selectedEventTickets?.QuantitySold,
            Type: selectedEventTickets?.Type,
            SaleStartDate: selectedEventTickets?.SaleStartDate,
            SaleEndDate: selectedEventTickets?.SaleEndDate,
            Benefits: [selectedEventTickets?.Benefits],
            TermsAndConditions: [selectedEventTickets?.TermsAndConditions],
            MediaMappings: {
                MediaFiles: [{}],
                Templates: []
            },


        }
        const eventTicketsData = {

            EventId: selectedEventTickets?.EventId,
            Name: selectedEventTickets?.Name,
            Description: selectedEventTickets?.Description,
            Price: selectedEventTickets?.Price,
            Currency: selectedEventTickets?.Currency,
            QuantityAvailable: selectedEventTickets?.QuantityAvailable,
            QuantitySold: selectedEventTickets?.QuantitySold,
            Type: selectedEventTickets?.Type,
            SaleStartDate: selectedEventTickets?.SaleStartDate,
            SaleEndDate: selectedEventTickets?.SaleEndDate,
            Benefits: [selectedEventTickets?.Benefits],
            TermsAndConditions: [selectedEventTickets?.TermsAndConditions],
            MediaMappings: {
                MediaFiles: [{}],
                Templates: []
            },

        }
        if (parmas?.Id > 0) {
            await dispatch(eventTickets.resetAction({ actionType: 'update' }))
            await dispatch(eventTickets.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets`, entity: 'eventTickets', jsonData: {

                    Records: [
                        eventTicketsData
                    ]

                }
            }))
                .then(() => {
                    back()
                });
        } else {
            await dispatch(eventTickets.resetAction({ actionType: 'create' }))
            await dispatch(eventTickets.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets`,
                entity: 'eventTickets',
                jsonData: {
                    Records: [
                        eventTicketsCreateItemData
                    ]
                }
            })).then(() => {
                back();
            });
        }
    }

    const back = () => {
        navigate('/agencies/event/event-tickets')
    }

    console.log(eventsTicketsQuery,"selectedEventTickets")
    return (
        <>

            {isLoading ? <PageLoader /> :
                <EventTicketsComponent
                    handleFormSubmit={handleFormSubmit}
                    back={back}
                    selectedEventTickets={selectedEventTickets}
                    handleInnerFormChange={handleInnerFormChange}
                    events={eventsListItems?.result?.items}
                />
            }
        </>
    )

}

export default AgencyEventTicket;